import { useCallback, useContext } from 'react'
import { GlobalLoaderContext } from '@components/GlobalLoaderProvider/GlobalLoaderContext'

const useGlobalLoader = () => {
  const { isActiveLoader, setLoader } = useContext(GlobalLoaderContext)

  const setLoading = useCallback((status: boolean) => {
    setLoader(status)
  }, [])

  return {
    loading: isActiveLoader,
    setLoading,
  }
}

export default useGlobalLoader
